import createRoute     from '@widesk-ui/tools/createRoute';
import ProfessionModel from '@models/website/ProfessionModel';

const route = createRoute.dashboardFromModel(
	ProfessionModel,
	'ProfessionDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
